import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { RuleDetailsRowData } from "../utils/historyRuleDetailsRows";
import styles from "../HistoryRuleDetails.module.scss";

export const RuleDetailsStatusCell = memo(
    ({ row }: { row: { original: RuleDetailsRowData } }) => {
        const { statusColumn } = row.original;

        if (statusColumn.kind === "diff") {
            return (
                <ViewTableCell className={styles.td}>
                    <div className={styles.removedText}>
                        {statusColumn.beforeStatus === "active"
                            ? "Active"
                            : "Archived"}
                    </div>
                    <div className={styles.addedText}>
                        {statusColumn.afterStatus === "active"
                            ? "Active"
                            : "Archived"}
                    </div>
                </ViewTableCell>
            );
        }

        return (
            <ViewTableCell>
                <span className={styles.statusNeutralText}>
                    {statusColumn.status === "active" ? "Active" : "Archived"}
                </span>
            </ViewTableCell>
        );
    },
);

RuleDetailsStatusCell.displayName = "RuleDetailsStatusCell";
